<template>
  <v-dialog v-model="dialog" persistent max-width="420">
    <template v-slot:activator="{ on }">
      <v-btn :loading="loading" :large="large" :small="small" :disabled="disabled" :color="color || 'error'" outline class="tertiary" v-on="on">
        <v-icon left>{{ icon || 'delete_forever' }}</v-icon>
        {{ label }}
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="headline">{{ title }}</v-card-title>
      <v-card-text>{{ text }}</v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :color="color || 'error'" @click="submit">
          <v-icon class="mr-1">{{ icon || 'delete_forever' }}</v-icon>
          {{ confirm || 'Remove' }}
        </v-btn>
        <v-btn depressed @click="close">{{$t('Button.Cancel')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
  export default {
    props: {
      label: String,
      title: String,
      text: String,
      confirm: String,
      color: String,
      icon: String,
      disabled: Boolean,
      loading: Boolean,
      small: Boolean,
      large: Boolean,
    },
    data() {
      return {
        dialog: false,
      }
    },
    methods: {
      close() {
        this.dialog = false
      },
      submit() {
        this.$emit('submit')
        this.close()
      },
    },
  }
</script>